import { ReactComponent as SearchIcon } from "assets/icons/search.svg";
import DataredeLogo from "assets/images/background-circle.svg";
import Button from "ui/Button";
import Chip from "ui/Chip";
import Heading from "ui/Text/Heading";
import Body from "ui/Text/Body";
import styled from "styled-components";
import { spacing } from "globalStyles";

const DEFAULT_DATAREDE_REDIRECT_URL = "https://datarede.pt/";

const PageNotFound = () => {
  return (
    <NotFoundContainer backgroundLogo={DataredeLogo}>
      <BackgroundColorComponent />
      <SearchIcon />
      <Chip className="chip">
        <Body variant="body3">ERRO 404</Body>
      </Chip>
      <Heading variant="h1" className="heading" align="center">
        Página não encontrada
      </Heading>
      <Body variant="body6" align="center" className="body">
        A página solicitada já não se encontra neste espaço. <br /> Pode ter sido removida
        ou o link já não existe
      </Body>
      <Button>
        <a href={process.env.DATAREDE_BASE_URL || DEFAULT_DATAREDE_REDIRECT_URL}>
          Voltar à página inicial
        </a>
      </Button>
    </NotFoundContainer>
  );
};

export default PageNotFound;

interface NotFoundContainerProps {
  backgroundLogo: string;
}

export const NotFoundContainer = styled.div<NotFoundContainerProps>`
  width: 100dvw;
  height: 100dvh;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  background-image: url(${({ backgroundLogo }) => backgroundLogo});
  background-repeat: no-repeat;
  background-position: right -120px bottom -120px;

  & > svg,
  & .chip {
    margin-bottom: ${spacing.medium}px;
  }

  & .heading {
    margin-bottom: 24px;
    font-weight: 400;
    font-size: 56px;
  }

  & .body {
    color: #585ca3;
    font-size: 24px;
    line-height: 32px;
  }

  & > button {
    margin-top: ${spacing.extraLarge}px;
  }
`;

export const BackgroundColorComponent = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.tertiary};
  z-index: -1;
`;
